import api from './api';
import { SiteDocument } from "@/mocks/data/vendorSitesService/siteDocument";

const { workflowTransitionServiceAPI, vendorServiceAPI } = api;

const FETCH_VENDOR_SITES_FORM_DATA_PATH = "/vendor/site/";
const FETCH_VENDOR_SITES_FORM_ONLOAD_DATA_PATH = "/vendor/site/onload";
const GET_ASSET_CONTENT_PATH = (assetId: string | number) => `/asset/${assetId}/content`;

/** Coalesce concurrent GET /vendor/site/onload (e.g. multiple Food Safety site panels mounting at once). */
let vendorSiteOnloadInflight: Promise<any> | null = null;


const vendorSitesFormInformation = {
  getVendorSiteDetailsById: async (
    siteId: string | number,
    ideaId?: string | number | null
  ): Promise<any> => {
    try {
      const path = `${FETCH_VENDOR_SITES_FORM_DATA_PATH}${siteId}`;
      const ideaIdStr =
        ideaId != null && String(ideaId).trim() !== "" ? String(ideaId).trim() : "";
      const url = ideaIdStr ? `${path}?ideaId=${encodeURIComponent(ideaIdStr)}` : path;

      const resp = await vendorServiceAPI.get(url);
      return resp?.data ?? null;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  getVendorSitesFormOnloadData: async (): Promise<any> => {
    if (vendorSiteOnloadInflight) {
      return vendorSiteOnloadInflight;
    }
    vendorSiteOnloadInflight = vendorServiceAPI
      .get(FETCH_VENDOR_SITES_FORM_ONLOAD_DATA_PATH)
      .then((resp) => resp?.data ?? null)
      .finally(() => {
        vendorSiteOnloadInflight = null;
      });
    return vendorSiteOnloadInflight;
  },
  getSiteDocumentData: async (): Promise<any> => {
    try {
      const resp = SiteDocument;
      return resp ?? null;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  downloadSiteDocumentPDF: async (assetId: string | number) => {
    try {
      const resp = await workflowTransitionServiceAPI.get(GET_ASSET_CONTENT_PATH(assetId), {
        responseType: 'blob',
      });
      return resp.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  updateVendorSite: async (siteId: string | number, payload: any) => {
    try {
      const path = `${FETCH_VENDOR_SITES_FORM_DATA_PATH}${siteId}`;
      
      const resp = await vendorServiceAPI.put(path, payload);
      return resp?.data ?? null;
    } catch (error: any) {
      console.error("Error updating vendor site:", error);
      throw error;
    }
  },
};

export default vendorSitesFormInformation;